// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe{width:100%;height:100%;border:0;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
